export const tenantId = 't1';
export const entityNames = {
  openCall: 'open_call',
  destination: 'destination',
  organization: 'organization',
};
export const roles = {
  superUser: 'superUser',
  guest: 'guest',
};
export const stageNames = {
  applicants: 'Applicants',
  jury: 'Jury Stage',
  finalists: 'Finalists',
  dismissed: 'Dismissed',
};
export const getUserSubject = (userEmail: string) => ({
  id: userEmail.toLowerCase().replaceAll('@', '_'),
  type: 'role',
});
export const entities = {
  organization: (id: string) => ({
    id,
    type: entityNames.organization,
  }),
  openCalls: {
    id: 'OpenCall',
    type: entityNames.openCall,
  },
  guest: {
    type: 'role',
    id: roles.guest,
  },
  superUser: {
    type: 'role',
    id: roles.superUser,
  },
};

export const relations = {
  superUser: 'super_user',
  guestUser: 'guest_user',
  member: 'member',
};

const crudPermissions = {
  create: 'create_application',
  delete: 'delete_application',
  view: 'view_application',
  update: 'update_application',
};

const stagePermissions = {
  viewCandidateInfo: 'view_candidate_info',
  viewJuryStage: 'view_jury_stage',
  engageWithCandidate: 'engage_with_candidate',
  manageStages: 'manage_stages',
  externalInvite: 'external_invite',
  contactCandidates: 'contact_canditates',
  removeCandidates: 'remove_candidates',
  moveCandidates: 'move_candidates',
  bulkAction: 'bulk_action',
  filterAndSearch: 'filter_and_search',
  exportCandidates: 'export_candidates',
};

export const permissions = {
  openCalls: {
    ...crudPermissions,
    // dashboard
    viewDashboardMetrics: 'view_dashboard_metrics',
    // stage
    ...stagePermissions,
  },
};
